




















































































import Component from 'vue-class-component';

import NpInput from './NpInput.vue';

@Component({
	inheritAttrs: false,
	extends: NpInput,
	props: {
		emptyOption: {
			type: [Boolean, String],
			default: false,
		},
		groupLabel: {
			type: String,
			default: '',
		},
		groupValues: {
			type: String,
			default: '',
		},
		optionLabel: {
			type: String,
			default: '',
		},
		optionValue: {
			type: String,
			default: '',
		},
		options: {
			type: Array,
		},
		placeholder: {
			type: String,
			default: '',
		},
		trackBy: {
			type: String,
			default: '',
		},
	},
	watch: {
		selectedValue(newValue) {
			(this as NpSelect).updateValue(newValue);
		},
		value(newValue) {
			(this as NpSelect).selectedValue = newValue;
		},
	},
})
export default class NpSelect extends NpInput {
		public emptyOption!: string|boolean;

		public groupLabel!: string;

		public groupValues!: string;

		public optionLabel!: string;

		public optionValue!: string;

		public options!: any[];

		public selectedValue: any = null;

		public trackBy: string = '';

		public get hasGroups() {
			return this.groupLabel && this.groupValues;
		}

		public created() {
			this.selectedValue = this.value;
		}
}
